import { DragStartEvent, DragEndEvent } from "@dnd-kit/core"
import { closestCenter, DndContext, DragOverlay, } from '@dnd-kit/core';
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { List } from "@mui/material";
import MyListItem from "./MyListItem";
import MySortableListItem from "./MySortableListItem";
import { useDefaultSensors } from './presets';
import { iKanbanItem } from './types';
import { useState } from "react";
import { iTreeItem } from "./types";
import TreeProvider, { useTreeContext } from "./TreeProvider";

interface TreeProps {
  items: Array<iTreeItem>,
}

interface NodeProps {
  id: number,
  depth: number,
}

function SortableNode({ id, depth }: NodeProps) {
  const { items } = useTreeContext();
  const [nodeItems, setNodeItems] = useState(items.filter(x => x.parent_id === id));
  const listProps = 0 === id ? {} : { component: 'div', disablePadding: true }
  const listItemProps = { sx: { pl: 2 * depth } }

  return (
    <SortableContext items={nodeItems}>
      <List {...listProps}>
        {nodeItems.map(nodeItem => (
          <MySortableListItem item={nodeItem} {...listItemProps}>
            <SortableNode id={nodeItem.id} depth={1 + depth} />
          </MySortableListItem>))}
      </List>
    </SortableContext>
  )
}

export default function({ items }: TreeProps) {
  return (
    <TreeProvider items={items}>
      <DndContext>
        <SortableNode id={0} depth={0} />
      </DndContext>
    </TreeProvider>
  );
}
